import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NetworkService } from '@damofire/data-angular-commons';
import { User } from '@damofire/data-security';
import { Division, DivisionService, RepresentativeType, UserService } from '@damofire/data-stas';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AutoUnsubscribe } from '../auto-unsubscribe.decorator';
import { ContactCardComponent } from '../contact-card/contact-card.component';
import { MatDivider } from '@angular/material/divider';
import { IfMyselfDirective } from '../security/if-myself.directive';

@AutoUnsubscribe()
@Component({
  imports: [CommonModule, TranslatePipe, ContactCardComponent, MatDivider, IfMyselfDirective],
  selector: 'app-side-menu-footer',
  templateUrl: './side-menu-footer.component.html',
  styleUrls: ['./side-menu-footer.component.scss'],
  standalone: true,
})
export class SideMenuFooterComponent {
  salesRep: Promise<User>;
  networkSub: Subscription;

  constructor(
    private readonly divisionService: DivisionService,
    private readonly userService: UserService,
    private readonly networkService: NetworkService,
  ) {}

  @Input()
  set division(division: string) {
    this.networkSub?.unsubscribe();
    this.networkSub = this.networkService.status.pipe(filter((c: boolean) => c)).subscribe(() => {
      console.log(`Got new division, looking for sales rep.`, division);
      this.salesRep = this.divisionService.getById(division).then(
        (d: Division) => this.resolveSalesRep(d),
        (err) => {
          console.error(`Cannot find sales representative for division: ${division}`, err);
          return undefined;
        },
      );
    });
  }

  private resolveSalesRep(division: Division): Promise<User> {
    if (division) {
      console.log(`warehouse infos resolved, looking for sales rep.`, division.representatives);
      const repData = division.representatives?.find((r) => r.type === RepresentativeType.sales);

      if (repData) {
        console.log(`Found one, resolving user infos.`, repData._id);
        return this.userService.get(repData._id);
      } else {
        console.log(`Warehouse has no sales rep.`);
      }
    }

    return undefined;
  }
}
